import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { MsalModule } from '@azure/msal-angular';
import { getMsalInstance, msalGuardConfig, msalInterceptorConfig } from './app/msal-auth/msal-config';
import { importProvidersFrom } from '@angular/core';
import { routes } from './app/routes/app.routes';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './app/interceptor/auth.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideToastr } from 'ngx-toastr';

async function main() {
  const msalInstance = await getMsalInstance();

  // Process any pending MSAL redirect BEFORE bootstrapping the app.
  // This ensures getActiveAccount() is reliable by the time the router
  // and guards execute, preventing the guard from overwriting the saved redirectUrl.
  try {
    const redirectResponse = await msalInstance.handleRedirectPromise();
    if (redirectResponse?.account) {
      msalInstance.setActiveAccount(redirectResponse.account);
    }
  } catch (e) {
    console.error('MSAL handleRedirectPromise error:', e);
  }

  bootstrapApplication(App, {
    providers: [
      provideAnimations(), // Required for ngx-toastr
        provideToastr({
        timeOut: 3000,
        positionClass: 'toast-bottom-right',
        preventDuplicates: true,
        closeButton: true,
        enableHtml: true
      }),
      provideRouter(routes, withComponentInputBinding()),
      provideHttpClient(withInterceptorsFromDi()),
      importProvidersFrom(
        MsalModule.forRoot(
          msalInstance,
          msalGuardConfig,
          msalInterceptorConfig
        )
      ),
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
      }
    ],
  });
}

main();
